import * as Yup from 'yup';
import { QuestionnaireFormQuestion } from 'types/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useValidationSchema = (questions: QuestionnaireFormQuestion[]) => {
  const { t } = useTranslation();
  const requiredMessage = t('requiredField');

  return useMemo(
    () =>
      Yup.object().shape(
        questions.reduce((acc, question) => {
          return {
            ...acc,
            [question.questionReference]:
              Yup.string().required(requiredMessage),
          };
        }, {}),
      ),
    [questions, requiredMessage],
  );
};

export default useValidationSchema;
